import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Sparkles } from 'lucide-react';
import { useUserRole } from '@/hooks/useUserRole';

export const RoleUpgradeNotice = () => {
  const { role, loading } = useUserRole();

  // Only show to regular users, not practitioners or other roles
  if (loading || role !== 'user') return null;

  return (
    <Alert className="mb-6 border-primary/50 bg-primary/5">
      <Sparkles className="h-5 w-5 text-primary" />
      <AlertTitle className="text-lg font-semibold">Become a Practitioner!</AlertTitle>
      <AlertDescription className="mt-2">
        Subscribing to a <strong>Practitioner plan</strong> will automatically upgrade
        your account to <strong>Practitioner status</strong>, giving you access to professional
        features and tools. Credit purchases do not include practitioner access.
      </AlertDescription>
    </Alert>
  );
};
